module.exports = __webpack_public_path__ + "static/video-okuliare-pre-afriku-e694954b43c94fb4fd53f251e015a3cc.mp4";